/**
 * @param {string} code
 * @param {Array} supportedCountries
 * @returns {boolean}
 */
export const isCountrySupported = (code, supportedCountries) => {
  return supportedCountries.filter(country => country.code === code).length === 1;
};

/**
 * Decide whether we locale countries choice should be shown
 * @param {string} locale user cookie locale
 * @param {boolean} showOnThisPage Is it even enabled on this page
 * @param {string} userCountryCode user geo location country
 * @param {string} pageCountryCode if page is country specific code of the country it's specific to
 * @param {Array} localeCountries Array of countries objects
 * @returns {*|boolean}
 */
export const shouldShowHeader = ({
  locale,
  showOnThisPage,
  userCountryCode,
  pageCountryCode,
  localeCountries,
}) => {
  if (!showOnThisPage || !isCountrySupported(userCountryCode, localeCountries)) {
    return false;
  }

  if (!locale && pageCountryCode !== userCountryCode) {
    return true;
  }

  if (locale && locale === userCountryCode && pageCountryCode !== locale && pageCountryCode !== 'GB') {
    return true;
  }

  if (locale === 'GB' && userCountryCode !== 'GB' && pageCountryCode === 'GB') {
    return true;
  }

  return false;
};
